var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { authoringApi } from "../api.js";
import { URL_SEGMENTS, TAGS } from "../common.js";
import "../../analysis/index.js";
import "../../feature/index.js";
import "../../mds/index.js";
import "../../xcard/index.js";
import "../../notification-hub/index.js";
import "../../ctm/index.js";
import "../../common.js";
import "../../types.js";
import "../../testutils.js";
import { getFetchArgs, providesList, LIST_TAG } from "../../utils.js";
import { UNIFIED_API_PRERELEASE_VERSION } from "../../../../resources/expapiunified/ExpAPIVUnified.constants.js";
import { experimentStepApi, useCreateOrUpdateExperimentStepMutation, useDeleteExperimentStepMutation, useGetExperimentStepByIdQuery, useLazyGetExperimentStepByIdQuery, useLazyQueryExperimentStepsQuery, usePrefetchExperimentSteps, useQueryExperimentStepsQuery } from "./experiment-steps.js";
import { experimentExtensionsApi, useCreateOrUpdateExperimentExtensionMutation, useDeleteExperimentExtensionMutation, useGetExperimentExtensionByIdQuery, useLazyGetExperimentExtensionByIdQuery, useLazyQueryExperimentExtensionsQuery, usePrefetchExperimentExtensions, useQueryExperimentExtensionsQuery } from "./experiment-extensions.js";
import { experimentationGroupApi, useCreateOrUpdateExperimentationGroupAudienceFilterMutation, useGetExperimentationGroupAudienceFilterByIdQuery, useGetSettingsForExperimentationGroupQuery, useLazyGetExperimentationGroupAudienceFilterByIdQuery, useLazyGetSettingsForExperimentationGroupQuery, useLazyQueryExperimentationGroupAudienceFiltersQuery, useLazyQueryExperimentationGroupsQuery, usePrefetchExperimentationGroups, useQueryExperimentationGroupAudienceFiltersQuery, useQueryExperimentationGroupsQuery } from "./experimentation-groups.js";
import { experimentationGroupSettingsApi, useCreateOrUpdateEgSettingsMutation, useLazyQueryExperimentationGroupSettingsQuery, usePrefetchExperimentationGroupSettings, useQueryExperimentationGroupSettingsQuery } from "./experimentation-group-settings.js";
import { gateTypeApi, useCreateOrUpdateGateTypeMutation, useDeleteGateTypeMutation, useGetGateTypeByIdQuery, useLazyGetGateTypeByIdQuery, useLazyQueryGateTypesQuery, usePrefetchGateTypes, useQueryGateTypesQuery } from "./gate-types.js";
import { useCreateOrUpdateVariantByIdMutation, useGetVariantByIdQuery, useGetVariantCompositionQuery, useLazyGetVariantByIdQuery, useLazyGetVariantCompositionQuery, useLazyQueryVariantsQuery, usePrefetchVariants, useQueryVariantsQuery, useUpdateVariantCompositionMutation, variantApi } from "./variants.js";
import "../../analysis/api.js";
import "../../analysis/endpoints/analysis.js";
import "../../feature/api.js";
import "../../feature/endpoints/feature-read.js";
import "../../mds/api.js";
import "../../mds/common.js";
import "../../mds/endpoints/system-health-banners.js";
import "../../xcard/api.js";
import "../../xcard/endpoints/alert.js";
import "../../xcard/endpoints/plugins/default-summary.js";
import "../../xcard/endpoints/incidents.js";
import "../../xcard/endpoints/insights.js";
import "../../xcard/endpoints/meta-data.js";
import "../../xcard/endpoints/quality-warnings.js";
import "../../xcard/endpoints/table.js";
import "../../xcard/endpoints/view.js";
import "../../notification-hub/api.js";
import "../../notification-hub/endpoints/notification-subscriptions.js";
import "../../notification-hub/common.js";
import "../../ctm/api.js";
import "../../ctm/common.js";
import "../../ctm/endpoints/compute-tasks.js";
const resource$9 = URL_SEGMENTS.ASSIGNMENT_SCOPE;
const assignmentScopeApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    queryAssignmentScopes: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$9, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.ASSIGNMENT_SCOPE)
    })
  })
});
const {
  usePrefetch: usePrefetchAssignmentScopes,
  useQueryAssignmentScopesQuery,
  useLazyQueryAssignmentScopesQuery
} = assignmentScopeApi;
const resource$8 = URL_SEGMENTS.ASSIGNMENT_UNIT;
const assignmentUnitApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentUnitById: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$8, payload }),
      providesTags: (result, error, { id }) => [{ type: TAGS.ASSIGNMENT_UNIT, id }]
    }),
    queryAssignmentUnits: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$8, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.ASSIGNMENT_UNIT)
    }),
    createOrUpdateAssignmentUnit: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$8, payload, method: "PUT" }),
      // If the response is 201 created, then we invalidate the list since it will affect ordering
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a;
        return providesList([entity], TAGS.ASSIGNMENT_UNIT, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201);
      },
      onQueryStarted: (_0, _1) => __async(void 0, [_0, _1], function* ({ id, workspaceId }, { dispatch, queryFulfilled, getState }) {
        try {
          const { data, meta } = yield queryFulfilled;
          dispatch(
            assignmentUnitApi.util.updateQueryData("getAssignmentUnitById", { id, workspaceId }, (draft) => {
              Object.assign(draft, data);
            })
          );
        } catch (e) {
        }
      })
    }),
    deleteAssignmentUnit: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$8, payload, method: "DELETE" }),
      invalidatesTags: (result, error, { id }) => providesList([{ id }], TAGS.ASSIGNMENT_UNIT)
    })
  })
});
const {
  usePrefetch: usePrefetchAssignmentUnits,
  useGetAssignmentUnitByIdQuery,
  useLazyGetAssignmentUnitByIdQuery,
  useQueryAssignmentUnitsQuery,
  useLazyQueryAssignmentUnitsQuery,
  useCreateOrUpdateAssignmentUnitMutation,
  useDeleteAssignmentUnitMutation
} = assignmentUnitApi;
const resource$7 = URL_SEGMENTS.AUDIENCE_FILTER;
const audienceFiltersApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getAudienceFilterById: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$7, payload }),
      providesTags: (result, error, { id }) => [{ type: TAGS.AUDIENCE_FILTER, id }]
    }),
    queryAudienceFilters: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$7, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.AUDIENCE_FILTER)
    })
  })
});
const {
  usePrefetch: usePrefetchAudienceFilters,
  useGetAudienceFilterByIdQuery,
  useLazyGetAudienceFilterByIdQuery,
  useQueryAudienceFiltersQuery,
  useLazyQueryAudienceFiltersQuery
} = audienceFiltersApi;
const resource$6 = URL_SEGMENTS.EXPERIMENT_OPERATION_SET;
const experimentOperationSetApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getExperimentOperationSetById: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$6, payload }),
      providesTags: (result, error, { id }) => [{ type: TAGS.EXPERIMENT_OPERATION_SET, id }]
    }),
    queryExperimentOperationSets: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$6, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.EXPERIMENT_OPERATION_SET)
    }),
    getExperimentOperationSetOperationChecks: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$6, payload, method: "GET", action: "check" }),
      providesTags: (result = []) => result.flatMap((r) => [
        ...r.experimentOperationSetId ? [{ type: TAGS.EXPERIMENT_OPERATION_SET, id: r.experimentOperationSetId }] : [],
        ...r.infoItems.filter((i) => !!i.gate).flatMap((i) => {
          var _a, _b;
          return [
            { type: TAGS.EXPERIMENT_OPERATION_SET, id: (_a = i.gate) == null ? void 0 : _a.experimentOperationSetId },
            { type: TAGS.GATE, id: (_b = i.gate) == null ? void 0 : _b.id }
          ];
        })
      ])
    }),
    createOrUpdateExperimentOperationSetAsync: builder.mutation(
      {
        query: (payload) => getFetchArgs({ resource: resource$6, payload, method: "PUT" }),
        invalidatesTags: (result, error, { entity }, meta) => {
          var _a;
          return providesList([entity], TAGS.EXPERIMENT_OPERATION_SET, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201);
        }
      }
    ),
    executeExperimentOperationSetById: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$6, payload, method: "POST", action: "execute" }),
      invalidatesTags: (result, error, { id }) => {
        var _a, _b;
        return [
          { type: TAGS.EXPERIMENT_OPERATION_SET, id },
          { type: TAGS.ISOLATION_GROUP_CAPACITY_OPERATION },
          ...(_b = (_a = result == null ? void 0 : result.experimentOperations) == null ? void 0 : _a.flatMap((op) => [
            ...op.fromStep ? [{ type: TAGS.EXPERIMENT_STEP, id: op.fromStep }] : [],
            ...op.toStep ? [{ type: TAGS.EXPERIMENT_STEP, id: op.toStep }] : []
          ])) != null ? _b : []
        ];
      }
    }),
    executeEmergencyShutdownExperimentOperationSetById: builder.mutation({
      query: (payload) => getFetchArgs({
        resource: resource$6,
        payload,
        method: "POST",
        action: "execute-emergency-shutdown",
        apiVersion: UNIFIED_API_PRERELEASE_VERSION
      }),
      invalidatesTags: (result, error, { id }) => {
        var _a, _b;
        return [
          { type: TAGS.EXPERIMENT_OPERATION_SET, id },
          { type: TAGS.ISOLATION_GROUP_CAPACITY_OPERATION },
          ...(_b = (_a = result == null ? void 0 : result.experimentOperations) == null ? void 0 : _a.flatMap((op) => [
            ...op.fromStep ? [{ type: TAGS.EXPERIMENT_STEP, id: op.fromStep }] : [],
            ...op.toStep ? [{ type: TAGS.EXPERIMENT_STEP, id: op.toStep }] : []
          ])) != null ? _b : []
        ];
      }
    }),
    executeExperimentOperations: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$6, payload: __spreadProps(__spreadValues({}, payload), { id: "" }), method: "POST", action: "execute" }),
      invalidatesTags: (result, error, { entity }) => {
        var _a, _b;
        return [
          { type: TAGS.ISOLATION_GROUP_CAPACITY_OPERATION },
          ...providesList(result, TAGS.EXPERIMENT, false),
          ...(_b = (_a = result == null ? void 0 : result.flatMap((e) => e.experimentSteps)) == null ? void 0 : _a.map((step) => ({ type: TAGS.EXPERIMENT_STEP, id: step.id }))) != null ? _b : []
        ];
      }
    }),
    executeEmergencyShutdownExperimentOperations: builder.mutation({
      query: (payload) => getFetchArgs({
        resource: resource$6,
        payload: __spreadProps(__spreadValues({}, payload), { id: "" }),
        method: "POST",
        action: "execute-emergency-shutdown",
        apiVersion: UNIFIED_API_PRERELEASE_VERSION
      }),
      invalidatesTags: (result, error, { entity }) => {
        var _a, _b;
        return [
          { type: TAGS.ISOLATION_GROUP_CAPACITY_OPERATION },
          ...providesList(result, TAGS.EXPERIMENT, false),
          ...(_b = (_a = result == null ? void 0 : result.flatMap((e) => e.experimentSteps)) == null ? void 0 : _a.map((step) => ({ type: TAGS.EXPERIMENT_STEP, id: step.id }))) != null ? _b : []
        ];
      }
    })
  })
});
const {
  usePrefetch: usePrefetchExperimentOperationSets,
  useGetExperimentOperationSetByIdQuery,
  useLazyGetExperimentOperationSetByIdQuery,
  useQueryExperimentOperationSetsQuery,
  useLazyQueryExperimentOperationSetsQuery,
  useGetExperimentOperationSetOperationChecksQuery,
  useLazyGetExperimentOperationSetOperationChecksQuery,
  useCreateOrUpdateExperimentOperationSetAsyncMutation,
  useExecuteExperimentOperationSetByIdMutation,
  useExecuteEmergencyShutdownExperimentOperationSetByIdMutation,
  useExecuteExperimentOperationsMutation,
  useExecuteEmergencyShutdownExperimentOperationsMutation
} = experimentOperationSetApi;
const resource$5 = URL_SEGMENTS.EXPERIMENT;
const experimentApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getExperimentById: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$5, payload }),
      providesTags: (result, error, { id }) => [
        { type: TAGS.EXPERIMENT, id },
        ...providesList(result == null ? void 0 : result.experimentSteps, TAGS.EXPERIMENT_STEP, false)
      ]
    }),
    queryExperiments: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$5, payload }),
      providesTags: (result) => {
        var _a;
        return [
          ...providesList(result == null ? void 0 : result.value, TAGS.EXPERIMENT),
          ...providesList(
            (_a = result == null ? void 0 : result.value) == null ? void 0 : _a.flatMap((e) => e.experimentSteps),
            TAGS.EXPERIMENT_STEP,
            false
          )
        ];
      },
      transformResponse: (res, meta, args) => __spreadProps(__spreadValues({}, res), {
        value: res.value.map((e) => {
          var _a;
          return __spreadProps(__spreadValues({}, e), {
            // Ensure experimentSteps is not null. This fixes a bug where querying for experiments with no steps returns null.
            experimentSteps: (_a = e.experimentSteps) != null ? _a : []
          });
        })
      })
    }),
    getExperimentOperationChecks: builder.query({
      query: (payload) => {
        const fetchArgs = getFetchArgs({ resource: resource$5, payload, apiVersion: UNIFIED_API_PRERELEASE_VERSION });
        return __spreadProps(__spreadValues({}, fetchArgs), {
          url: `${fetchArgs.url}/operations`
        });
      },
      providesTags: (result, error, { id }) => (result != null ? result : []).flatMap((r) => [
        { type: TAGS.EXPERIMENT_OPERATION_SET, id: r.experimentOperationSetId },
        { type: TAGS.EXPERIMENT, id },
        ...r.infoItems.filter((i) => !!(i == null ? void 0 : i.gate)).flatMap((i) => {
          var _a, _b;
          return [
            { type: TAGS.EXPERIMENT_OPERATION_SET, id: (_a = i.gate) == null ? void 0 : _a.experimentOperationSetId },
            { type: TAGS.GATE, id: (_b = i.gate) == null ? void 0 : _b.id }
          ];
        })
      ])
    }),
    deleteExperiment: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$5, payload, method: "DELETE" }),
      invalidatesTags: (result, error, { id }, meta) => {
        var _a, _b;
        return [
          ...providesList([{ id }], TAGS.EXPERIMENT),
          ...providesList([], TAGS.EXPERIMENT_OPERATION_SET, (_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.ok),
          ...providesList([], TAGS.GATE, (_b = meta == null ? void 0 : meta.response) == null ? void 0 : _b.ok)
        ];
      }
    }),
    createOrUpdateExperiment: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$5, payload, method: "PUT" }),
      // If the response is 201 created, then we invalidate the list since it will affect ordering
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a, _b, _c;
        return [
          ...providesList([entity], TAGS.EXPERIMENT, (_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.ok),
          ...providesList([], TAGS.EXPERIMENT_OPERATION_SET, (_b = meta == null ? void 0 : meta.response) == null ? void 0 : _b.ok),
          ...providesList([], TAGS.GATE, (_c = meta == null ? void 0 : meta.response) == null ? void 0 : _c.ok)
        ];
      }
    }),
    iterateExperiment: builder.mutation({
      query: (payload) => getFetchArgs({
        resource: resource$5,
        payload,
        method: "POST",
        action: "iterate"
      }),
      invalidatesTags: (result, error, { id }, meta) => {
        var _a, _b, _c;
        return [
          ...providesList([{ id }], TAGS.EXPERIMENT, (_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.ok),
          ...providesList([], TAGS.EXPERIMENT_OPERATION_SET, (_b = meta == null ? void 0 : meta.response) == null ? void 0 : _b.ok),
          ...providesList([], TAGS.GATE, (_c = meta == null ? void 0 : meta.response) == null ? void 0 : _c.ok)
        ];
      }
    })
  })
});
const {
  usePrefetch: usePrefetchExperiments,
  useGetExperimentByIdQuery,
  useLazyGetExperimentByIdQuery,
  useQueryExperimentsQuery,
  useLazyQueryExperimentsQuery,
  useGetExperimentOperationChecksQuery,
  useLazyGetExperimentOperationChecksQuery,
  useCreateOrUpdateExperimentMutation,
  useIterateExperimentMutation
} = experimentApi;
const resource$4 = URL_SEGMENTS.FEATURE;
const featureApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureById: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$4, payload }),
      providesTags: (result, error, { id }) => {
        var _a;
        return [
          { type: TAGS.FEATURE, id },
          ...providesList(result == null ? void 0 : result.experiments, TAGS.EXPERIMENT, false),
          ...providesList(
            (_a = result == null ? void 0 : result.experiments) == null ? void 0 : _a.flatMap((e) => e.experimentSteps),
            TAGS.EXPERIMENT_STEP,
            false
          ),
          ...providesList(result == null ? void 0 : result.progressions, TAGS.PROGRESSION, false),
          ...providesList(result == null ? void 0 : result.variants, TAGS.VARIANT, false)
        ];
      }
    }),
    createOrUpdateFeature: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$4, payload, method: "PUT" }),
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a, _b, _c, _d, _e;
        return [
          ...providesList([entity], TAGS.FEATURE, (_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.ok),
          // Invalidate progression tag for when progression is added to a feature through feature update
          ...providesList(entity.progressions, TAGS.PROGRESSION, (_b = meta == null ? void 0 : meta.response) == null ? void 0 : _b.ok),
          ...providesList(
            (_c = result == null ? void 0 : result.experiments) == null ? void 0 : _c.flatMap((e) => e.experimentSteps),
            TAGS.EXPERIMENT_STEP,
            (_d = meta == null ? void 0 : meta.response) == null ? void 0 : _d.ok
          ),
          ...providesList(result == null ? void 0 : result.variants, TAGS.VARIANT, (_e = meta == null ? void 0 : meta.response) == null ? void 0 : _e.ok)
        ];
      }
    }),
    archiveFeature: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$4, payload, method: "POST", action: "archive" }),
      invalidatesTags: (result, error, { id }, meta) => {
        var _a, _b, _c, _d, _e;
        return [
          { type: TAGS.FEATURE, id },
          ...providesList(result == null ? void 0 : result.experiments, TAGS.EXPERIMENT, (_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.ok),
          ...providesList(result == null ? void 0 : result.progressions, TAGS.PROGRESSION, (_b = meta == null ? void 0 : meta.response) == null ? void 0 : _b.ok),
          ...providesList(
            (_c = result == null ? void 0 : result.experiments) == null ? void 0 : _c.flatMap((e) => e.experimentSteps),
            TAGS.EXPERIMENT_STEP,
            (_d = meta == null ? void 0 : meta.response) == null ? void 0 : _d.ok
          ),
          ...providesList(result == null ? void 0 : result.variants, TAGS.VARIANT, (_e = meta == null ? void 0 : meta.response) == null ? void 0 : _e.ok)
        ];
      }
    }),
    // select: id, name, eg, list of progression ids
    queryFeatures: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$4, payload }),
      providesTags: (result, error, payload) => {
        var _a, _b, _c, _d;
        return [
          ...providesList(result == null ? void 0 : result.value, TAGS.FEATURE),
          // TODO - only provide these tags if the child properties are fully expanded
          ...providesList(
            (_a = result == null ? void 0 : result.value) == null ? void 0 : _a.flatMap((f) => {
              var _a2;
              return (_a2 = f.experiments) != null ? _a2 : [];
            }),
            TAGS.EXPERIMENT,
            false
          ),
          ...providesList(
            (_b = result == null ? void 0 : result.value) == null ? void 0 : _b.flatMap((f) => {
              var _a2;
              return (_a2 = f.progressions) != null ? _a2 : [];
            }),
            TAGS.PROGRESSION,
            false
          ),
          ...providesList(
            (_c = result == null ? void 0 : result.value) == null ? void 0 : _c.flatMap((f) => {
              var _a2;
              return (_a2 = f.experiments) == null ? void 0 : _a2.flatMap((e) => {
                var _a3;
                return (_a3 = e.experimentSteps) != null ? _a3 : [];
              });
            }),
            TAGS.EXPERIMENT_STEP,
            false
          ),
          ...providesList(
            (_d = result == null ? void 0 : result.value) == null ? void 0 : _d.flatMap((f) => {
              var _a2;
              return (_a2 = f.variants) != null ? _a2 : [];
            }),
            TAGS.VARIANT,
            false
          )
        ];
      }
    }),
    getFeatureOperationChecks: builder.query({
      query: (payload) => {
        const fetchArgs = getFetchArgs({ resource: resource$4, payload, apiVersion: UNIFIED_API_PRERELEASE_VERSION });
        return __spreadProps(__spreadValues({}, fetchArgs), {
          url: `${fetchArgs.url}/operation-checks`
        });
      },
      providesTags: (result) => (result != null ? result : []).flatMap((r) => [
        { type: TAGS.EXPERIMENT_OPERATION_SET, id: r.experimentOperationSetId },
        ...r.infoItems.filter((i) => !!i.gate).flatMap((i) => {
          var _a, _b;
          return [
            { type: TAGS.EXPERIMENT_OPERATION_SET, id: (_a = i.gate) == null ? void 0 : _a.experimentOperationSetId },
            { type: TAGS.GATE, id: (_b = i.gate) == null ? void 0 : _b.id }
          ];
        })
      ])
    }),
    deleteFeature: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$4, payload, method: "DELETE" }),
      invalidatesTags: (result, error, { id }) => [
        ...providesList([{ id }], TAGS.FEATURE)
        // ...providesList([{ id }], TAGS.EXPERIMENT), // TODO - invalidate experiments with this feature id. maybe we need a new tag type for this case
      ]
    }),
    /**
     * Feature history
     */
    getFeatureEventsById: builder.query({
      query: (payload) => {
        const fetchArgs = getFetchArgs({ resource: resource$4, payload });
        return __spreadProps(__spreadValues({}, fetchArgs), {
          url: `${fetchArgs.url}/events`
        });
      },
      providesTags: (result, error, { id }) => [{ type: TAGS.FEATURE, id }]
    })
  })
});
const {
  usePrefetch: usePrefetchFeatures,
  useGetFeatureByIdQuery,
  useLazyGetFeatureByIdQuery,
  useQueryFeaturesQuery,
  useLazyQueryFeaturesQuery,
  useGetFeatureOperationChecksQuery,
  useLazyGetFeatureOperationChecksQuery,
  useCreateOrUpdateFeatureMutation,
  useArchiveFeatureMutation,
  useDeleteFeatureMutation,
  useGetFeatureEventsByIdQuery
} = featureApi;
const resource$3 = URL_SEGMENTS.GATE;
const gatesApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getGateById: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$3, payload }),
      providesTags: (result, error, { id }) => [{ type: TAGS.GATE, id }]
    }),
    queryGates: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$3, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.GATE)
    }),
    createOrUpdateGate: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$3, payload, method: "PUT" }),
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a;
        return providesList([entity], TAGS.GATE, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201);
      },
      onQueryStarted: (_0, _1) => __async(void 0, [_0, _1], function* ({ id, workspaceId }, { dispatch, queryFulfilled, getState }) {
        try {
          const { data, meta } = yield queryFulfilled;
          dispatch(
            gatesApi.util.updateQueryData("getGateById", { workspaceId, id: data.id }, (draft) => {
              Object.assign(draft, data);
            })
          );
        } catch (e) {
        }
      })
    }),
    deleteGate: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$3, payload, method: "DELETE" }),
      invalidatesTags: (result, error, { id }) => providesList([{ id }], TAGS.GATE)
    })
  })
});
const {
  usePrefetch: usePrefetchGates,
  useGetGateByIdQuery,
  useLazyGetGateByIdQuery,
  useQueryGatesQuery,
  useLazyQueryGatesQuery,
  useCreateOrUpdateGateMutation,
  useDeleteGateMutation
} = gatesApi;
const resource$2 = URL_SEGMENTS.ISOLATION_GROUP;
const isolationGroupsApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getIsolationGroupById: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$2, payload }),
      providesTags: (result, eror, { id }) => [{ type: TAGS.ISOLATION_GROUP, id }]
    }),
    queryIsolationGroups: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$2, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.ISOLATION_GROUP)
    }),
    createOrUpdateIsolationGroup: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$2, payload, method: "PUT" }),
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a;
        return providesList([entity], TAGS.ISOLATION_GROUP, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201);
      }
    }),
    deleteIsolationGroup: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$2, payload, method: "DELETE" }),
      invalidatesTags: (result, error, { id }) => providesList([{ id }], TAGS.ISOLATION_GROUP)
    }),
    getTrafficUsage: builder.query({
      query: (payload) => {
        const fetchArgs = getFetchArgs({ resource: resource$2, payload, method: "POST", apiVersion: UNIFIED_API_PRERELEASE_VERSION });
        return __spreadProps(__spreadValues({}, fetchArgs), {
          url: `${fetchArgs.url}/trafficUsage`
        });
      },
      // TODO - figure out how we can invalidate this tag for a feature's IG when an operation set/experiment is executed
      // For now we can just use the tag without an ID to invalidate all traffic usage requests
      providesTags: () => [{ type: TAGS.ISOLATION_GROUP_CAPACITY_OPERATION }]
    })
  })
});
const {
  usePrefetch: usePrefetchIsolationGroups,
  useGetIsolationGroupByIdQuery,
  useLazyGetIsolationGroupByIdQuery,
  useQueryIsolationGroupsQuery,
  useLazyQueryIsolationGroupsQuery,
  useGetTrafficUsageQuery,
  useLazyGetTrafficUsageQuery,
  useCreateOrUpdateIsolationGroupMutation,
  useDeleteIsolationGroupMutation
} = isolationGroupsApi;
const resource$1 = URL_SEGMENTS.PROGRESSION;
const progressionApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getProgressionById: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$1, payload }),
      providesTags: (result, error, { id }) => [{ type: TAGS.PROGRESSION, id }]
    }),
    queryProgressions: builder.query({
      query: (payload) => getFetchArgs({ resource: resource$1, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.PROGRESSION)
    }),
    createOrUpdateProgression: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$1, payload, method: "PUT" }),
      invalidatesTags: (result, error, { id, entity }, meta) => {
        var _a;
        return [
          ...providesList([{ id }], TAGS.PROGRESSION, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201),
          { type: TAGS.FEATURE, id: entity.featureId }
        ];
      }
    }),
    deleteProgression: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$1, payload, method: "DELETE" }),
      invalidatesTags: (result, error, { id }) => providesList([{ id }], TAGS.PROGRESSION)
    }),
    iterateProgression: builder.mutation({
      query: (payload) => getFetchArgs({ resource: resource$1, payload, method: "POST", action: "iterate" }),
      invalidatesTags: (result, error, { id, entity }) => [{ type: TAGS.PROGRESSION, id: LIST_TAG }]
    })
  })
});
const {
  usePrefetch: usePrefetchProgressions,
  useGetProgressionByIdQuery,
  useLazyGetProgressionByIdQuery,
  useQueryProgressionsQuery,
  useLazyQueryProgressionsQuery,
  useCreateOrUpdateProgressionMutation,
  useDeleteProgressionMutation,
  useIterateProgressionMutation
} = progressionApi;
const resource = URL_SEGMENTS.PROGRESSION_TEMPLATE;
const progressionTemplatesApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getProgressionTemplateById: builder.query({
      query: (payload) => getFetchArgs({ resource, payload }),
      providesTags: (result, error, { id }) => [{ type: TAGS.PROGRESSION_TEMPLATE, id }]
    }),
    queryProgressionTemplates: builder.query({
      query: (payload) => getFetchArgs({ resource, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.PROGRESSION_TEMPLATE)
    }),
    createOrUpdateProgressionTemplate: builder.mutation({
      query: (payload) => getFetchArgs({ resource, payload, method: "PUT" }),
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a;
        return providesList([entity], TAGS.PROGRESSION_TEMPLATE, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201);
      },
      onQueryStarted: (_0, _1) => __async(void 0, [_0, _1], function* ({ entity }, { dispatch }) {
      })
    }),
    deleteProgressionTemplate: builder.mutation({
      query: (payload) => getFetchArgs({ resource, payload, method: "DELETE" }),
      invalidatesTags: (result, error, { id }) => providesList([{ id }], TAGS.PROGRESSION_TEMPLATE)
    })
  })
});
const {
  usePrefetch: usePrefetchProgressionTemplates,
  useGetProgressionTemplateByIdQuery,
  useLazyGetProgressionTemplateByIdQuery,
  useQueryProgressionTemplatesQuery,
  useLazyQueryProgressionTemplatesQuery,
  useCreateOrUpdateProgressionTemplateMutation,
  useDeleteProgressionTemplateMutation
} = progressionTemplatesApi;
export {
  assignmentScopeApi,
  assignmentUnitApi,
  audienceFiltersApi,
  experimentApi,
  experimentExtensionsApi,
  experimentOperationSetApi,
  experimentStepApi,
  experimentationGroupApi,
  experimentationGroupSettingsApi,
  featureApi,
  gateTypeApi,
  gatesApi,
  isolationGroupsApi,
  progressionApi,
  progressionTemplatesApi,
  useArchiveFeatureMutation,
  useCreateOrUpdateAssignmentUnitMutation,
  useCreateOrUpdateEgSettingsMutation,
  useCreateOrUpdateExperimentExtensionMutation,
  useCreateOrUpdateExperimentMutation,
  useCreateOrUpdateExperimentOperationSetAsyncMutation,
  useCreateOrUpdateExperimentStepMutation,
  useCreateOrUpdateExperimentationGroupAudienceFilterMutation,
  useCreateOrUpdateFeatureMutation,
  useCreateOrUpdateGateMutation,
  useCreateOrUpdateGateTypeMutation,
  useCreateOrUpdateIsolationGroupMutation,
  useCreateOrUpdateProgressionMutation,
  useCreateOrUpdateProgressionTemplateMutation,
  useCreateOrUpdateVariantByIdMutation,
  useDeleteAssignmentUnitMutation,
  useDeleteExperimentExtensionMutation,
  useDeleteExperimentStepMutation,
  useDeleteFeatureMutation,
  useDeleteGateMutation,
  useDeleteGateTypeMutation,
  useDeleteIsolationGroupMutation,
  useDeleteProgressionMutation,
  useDeleteProgressionTemplateMutation,
  useExecuteEmergencyShutdownExperimentOperationSetByIdMutation,
  useExecuteEmergencyShutdownExperimentOperationsMutation,
  useExecuteExperimentOperationSetByIdMutation,
  useExecuteExperimentOperationsMutation,
  useGetAssignmentUnitByIdQuery,
  useGetAudienceFilterByIdQuery,
  useGetExperimentByIdQuery,
  useGetExperimentExtensionByIdQuery,
  useGetExperimentOperationChecksQuery,
  useGetExperimentOperationSetByIdQuery,
  useGetExperimentOperationSetOperationChecksQuery,
  useGetExperimentStepByIdQuery,
  useGetExperimentationGroupAudienceFilterByIdQuery,
  useGetFeatureByIdQuery,
  useGetFeatureEventsByIdQuery,
  useGetFeatureOperationChecksQuery,
  useGetGateByIdQuery,
  useGetGateTypeByIdQuery,
  useGetIsolationGroupByIdQuery,
  useGetProgressionByIdQuery,
  useGetProgressionTemplateByIdQuery,
  useGetSettingsForExperimentationGroupQuery,
  useGetTrafficUsageQuery,
  useGetVariantByIdQuery,
  useGetVariantCompositionQuery,
  useIterateExperimentMutation,
  useIterateProgressionMutation,
  useLazyGetAssignmentUnitByIdQuery,
  useLazyGetAudienceFilterByIdQuery,
  useLazyGetExperimentByIdQuery,
  useLazyGetExperimentExtensionByIdQuery,
  useLazyGetExperimentOperationChecksQuery,
  useLazyGetExperimentOperationSetByIdQuery,
  useLazyGetExperimentOperationSetOperationChecksQuery,
  useLazyGetExperimentStepByIdQuery,
  useLazyGetExperimentationGroupAudienceFilterByIdQuery,
  useLazyGetFeatureByIdQuery,
  useLazyGetFeatureOperationChecksQuery,
  useLazyGetGateByIdQuery,
  useLazyGetGateTypeByIdQuery,
  useLazyGetIsolationGroupByIdQuery,
  useLazyGetProgressionByIdQuery,
  useLazyGetProgressionTemplateByIdQuery,
  useLazyGetSettingsForExperimentationGroupQuery,
  useLazyGetTrafficUsageQuery,
  useLazyGetVariantByIdQuery,
  useLazyGetVariantCompositionQuery,
  useLazyQueryAssignmentScopesQuery,
  useLazyQueryAssignmentUnitsQuery,
  useLazyQueryAudienceFiltersQuery,
  useLazyQueryExperimentExtensionsQuery,
  useLazyQueryExperimentOperationSetsQuery,
  useLazyQueryExperimentStepsQuery,
  useLazyQueryExperimentationGroupAudienceFiltersQuery,
  useLazyQueryExperimentationGroupSettingsQuery,
  useLazyQueryExperimentationGroupsQuery,
  useLazyQueryExperimentsQuery,
  useLazyQueryFeaturesQuery,
  useLazyQueryGateTypesQuery,
  useLazyQueryGatesQuery,
  useLazyQueryIsolationGroupsQuery,
  useLazyQueryProgressionTemplatesQuery,
  useLazyQueryProgressionsQuery,
  useLazyQueryVariantsQuery,
  usePrefetchAssignmentScopes,
  usePrefetchAssignmentUnits,
  usePrefetchAudienceFilters,
  usePrefetchExperimentExtensions,
  usePrefetchExperimentOperationSets,
  usePrefetchExperimentSteps,
  usePrefetchExperimentationGroupSettings,
  usePrefetchExperimentationGroups,
  usePrefetchExperiments,
  usePrefetchFeatures,
  usePrefetchGateTypes,
  usePrefetchGates,
  usePrefetchIsolationGroups,
  usePrefetchProgressionTemplates,
  usePrefetchProgressions,
  usePrefetchVariants,
  useQueryAssignmentScopesQuery,
  useQueryAssignmentUnitsQuery,
  useQueryAudienceFiltersQuery,
  useQueryExperimentExtensionsQuery,
  useQueryExperimentOperationSetsQuery,
  useQueryExperimentStepsQuery,
  useQueryExperimentationGroupAudienceFiltersQuery,
  useQueryExperimentationGroupSettingsQuery,
  useQueryExperimentationGroupsQuery,
  useQueryExperimentsQuery,
  useQueryFeaturesQuery,
  useQueryGateTypesQuery,
  useQueryGatesQuery,
  useQueryIsolationGroupsQuery,
  useQueryProgressionTemplatesQuery,
  useQueryProgressionsQuery,
  useQueryVariantsQuery,
  useUpdateVariantCompositionMutation,
  variantApi
};
//# sourceMappingURL=index.js.map
